import Icon from '../components/Icon.vue'

Icon.register({
  memory: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 130.9V96C640 78.3 625.7 64 608 64H32C14.3 64 0 78.3 0 96V130.9C18.6 137.6 32 155.1 32 176S18.6 214.4 0 221.1V320H640V221.1C621.4 214.4 608 196.9 608 176S621.4 137.6 640 130.9zM224 256H160V128H224V256zM352 256H288V128H352V256zM480 256H416V128H480V256zM0 448H64V421.3C64 412.5 71.2 405.3 80 405.3S96 412.5 96 421.3V448H224V421.3C224 412.5 231.2 405.3 240 405.3S256 412.5 256 421.3V448H384V421.3C384 412.5 391.2 405.3 400 405.3S416 412.5 416 421.3V448H544V421.3C544 412.5 551.2 405.3 560 405.3S576 412.5 576 421.3V448H640V352H0V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/memory.js
// module id = YATI
// module chunks = 144